"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f120 = void 0;
exports.f120 = {
    "xagua": [
        60
    ],
    "xiandao": [
        71
    ],
    "xk": [
        269,
        7074,
        7094,
        7099
    ],
    "xârâcùù": [
        319
    ],
    "xaracuu": [
        319
    ],
    "xaracii": [
        319
    ],
    "xx": [
        438,
        1698,
        5665,
        5778,
        5837,
        5881,
        5911,
        5918,
        5919,
        5941,
        5974,
        6001,
        6002,
        6518,
        6894,
        6997,
        7029,
        7030,
        7031,
        7032,
        7067,
        7079,
        7082,
        7206,
        7222,
        7254,
        7257,
        7258,
        7261,
        7525,
        7543,
        7679,
        7755,
        7820,
        7840,
        7841,
        7842,
        7845,
        7854,
        7958,
        8392,
        8393,
        8394,
        8403,
        8404,
        8413,
        8414,
        8422,
        8427,
        8428,
        8429,
        8430,
        8432,
        8433,
        8434,
        8435,
        8436,
        8438,
        8439,
        8440,
        8441,
        8442,
        8444,
        8445,
        8447,
        8450,
        8455,
        8460,
        8461,
        8464,
        8467,
        8469,
        8474,
        8475,
        8476,
        8478,
        8480,
        8482,
        8484,
        8488,
        8518,
        8521,
        8522,
        8523,
        8524,
        8525,
        8526,
        8527,
        8528,
        8534,
        8540,
        8558,
        8565,
        8590,
        8607,
        8629,
        8643,
        8650,
        8715
    ],
    "xingú": [
        472
    ],
    "xingú asuriní": [
        472
    ],
    "xiaoshanhua": [
        486,
        487
    ],
    "xârâgurè": [
        571
    ],
    "xaragure": [
        571
    ],
    "xan": [
        1320
    ],
    "xanyaxo": [
        1320
    ],
    "xilenge": [
        1374
    ],
    "xuabo": [
        1458
    ],
    "xop": [
        1529
    ],
    "xibitaoan": [
        1563
    ],
    "xong": [
        1566
    ],
    "xavier": [
        1568
    ],
    "xianyou": [
        1593
    ],
    "xing": [
        1593,
        6365
    ],
    "xinghua": [
        1593
    ],
    "xaroxa": [
        1848
    ],
    "xuyadzitaya": [
        2004
    ],
    "xwen": [
        2063
    ],
    "ximoluo": [
        2239
    ],
    "xinlong-muya": [
        2251
    ],
    "xálima": [
        2346
    ],
    "xãlima": [
        2346
    ],
    "xi": [
        2523,
        2524,
        2525,
        2983,
        4315
    ],
    "xwla": [
        2562,
        8697
    ],
    "xaad kil": [
        2890
    ],
    "xaad": [
        2890
    ],
    "xaat kíl": [
        2890
    ],
    "xaat": [
        2890
    ],
    "x̱aad kíl": [
        2890
    ],
    "x̱aad": [
        2890
    ],
    "x̱aat kíl": [
        2890
    ],
    "x̱aat": [
        2890
    ],
    "xinminhua": [
        2893,
        2894,
        2895
    ],
    "xenaksialakala": [
        2905
    ],
    "xaaydaa kil": [
        2908
    ],
    "xaaydaa": [
        2908
    ],
    "xwaga": [
        2928
    ],
    "xibita": [
        2938
    ],
    "xibitoana": [
        2938
    ],
    "xereu": [
        2954
    ],
    "xerewyana": [
        2954
    ],
    "xijia miao": [
        2983
    ],
    "xijia": [
        2983
    ],
    "ximahe miao": [
        2983
    ],
    "ximahe": [
        2983
    ],
    "xauni": [
        3004
    ],
    "xá u ní": [
        3004
    ],
    "xá": [
        3004,
        3710,
        4302,
        4313,
        9110
    ],
    "xiang": [
        3061,
        3062
    ],
    "xiang chinese": [
        3061,
        3062
    ],
    "xunzal": [
        3095
    ],
    "xinag": [
        3214
    ],
    "xit’an": [
        3214
    ],
    "xwja": [
        3294
    ],
    "xubʼal": [
        3307
    ],
    "xebero": [
        3344
    ],
    "xihuila": [
        3344
    ],
    "xivaro": [
        3376
    ],
    "xaasongaxango": [
        3471
    ],
    "xaasonga": [
        3471
    ],
    "xasonga": [
        3471
    ],
    "xasongo": [
        3471
    ],
    "xasonke": [
        3471
    ],
    "xanty": [
        3506
    ],
    "xere": [
        3542
    ],
    "xuay": [
        3550,
        3551,
        3552
    ],
    "xuoi": [
        3550,
        3551,
        3552
    ],
    "xishuangbanna dai": [
        3645,
        3646
    ],
    "xishuangbanna": [
        3645,
        3646
    ],
    "xvarshi": [
        3665
    ],
    "xvarshik": [
        3665
    ],
    "xen": [
        3702,
        3703,
        3704
    ],
    "xa cau": [
        3702,
        3703,
        3704
    ],
    "xa": [
        3702,
        3703,
        3704,
        3710,
        6062,
        6063,
        6777,
        8923,
        8924,
        8925,
        8926
    ],
    "xakas": [
        3705
    ],
    "xinalug": [
        3707
    ],
    "xa ai": [
        3710
    ],
    "xa bung": [
        3710
    ],
    "xa dang": [
        3710
    ],
    "xa don": [
        3710
    ],
    "xa hoc": [
        3710
    ],
    "xa xua": [
        3710
    ],
    "xua": [
        3710
    ],
    "xá khao": [
        3710,
        4313
    ],
    "xorasan": [
        3817
    ],
    "xorasan turkic": [
        3817
    ],
    "xung": [
        3843
    ],
    "xaixai": [
        4006
    ],
    "xû": [
        4006
    ],
    "xucó": [
        4181
    ],
    "xocó": [
        4181,
        7463
    ],
    "xokó": [
        4181
    ],
    "xokó-karirí": [
        4181
    ],
    "xukuru kariri": [
        4181
    ],
    "xukuru": [
        4181
    ],
    "xukurú": [
        8584,
        4181
    ],
    "xhudeo-espanjol": [
        4189,
        4190,
        4191
    ],
    "xá phó": [
        4302
    ],
    "xá chien": [
        4313
    ],
    "xá lay": [
        4313
    ],
    "xaayo": [
        4368
    ],
    "xʷəlšucid": [
        4536
    ],
    "xiriwai": [
        4608
    ],
    "xuriwai": [
        4608
    ],
    "xayacatlán de bravo": [
        4812
    ],
    "xayacatlán": [
        4812
    ],
    "xiangxi": [
        4918,
        5139
    ],
    "xapaitíiso": [
        5246
    ],
    "xalitla nahuatl": [
        5439
    ],
    "xalitla": [
        5439
    ],
    "xo’boó": [
        6051
    ],
    "xi’oi": [
        6056
    ],
    "xa chung chá": [
        6062,
        6063
    ],
    "xi’iuy": [
        6216
    ],
    "xin mul": [
        6365
    ],
    "xin": [
        6365
    ],
    "xing mun": [
        6365
    ],
    "xingmoun": [
        6365
    ],
    "xinh mul": [
        6365
    ],
    "xinh": [
        6365
    ],
    "xinh mun": [
        6365
    ],
    "xinh-mun": [
        6365
    ],
    "xironga": [
        6569
    ],
    "xirhonga": [
        6569
    ],
    "xwarîn": [
        6753
    ],
    "xodang": [
        6777
    ],
    "xiao hua miao": [
        6801
    ],
    "xiao": [
        6801
    ],
    "xirianá": [
        6831
    ],
    "xirixana": [
        6831
    ],
    "xipibo": [
        6850
    ],
    "xikiyana": [
        6876
    ],
    "xikujana": [
        6876
    ],
    "xibe": [
        6899,
        6900,
        6901,
        6902
    ],
    "xibo": [
        6899,
        6900,
        6901,
        6902
    ],
    "xaek": [
        6913
    ],
    "xec": [
        6913
    ],
    "xek": [
        6913
    ],
    "xʷəlšuʔcid": [
        6946
    ],
    "xa-dieng": [
        7165
    ],
    "xtieng": [
        7165
    ],
    "xumi": [
        7256
    ],
    "xâne": [
        7425
    ],
    "xicotepec": [
        7649
    ],
    "xicotepec de juárez totonac": [
        7649
    ],
    "xicotepec totonac": [
        7649
    ],
    "xinolatépetl": [
        7691
    ],
    "xinolatépetl totonac": [
        7691
    ],
    "xinulajgsípij totonaco": [
        7691
    ],
    "xinulajgsípij": [
        7691
    ],
    "xnaꞌánj nu̱ꞌ": [
        7702
    ],
    "xnaꞌánj": [
        7702
    ],
    "xitsonga": [
        7727,
        7728
    ],
    "xichangana": [
        7727,
        7728
    ],
    "xitshwa": [
        7731
    ],
    "xitswa": [
        7731
    ],
    "xun": [
        8684,
        8052
    ],
    "xirima": [
        8114
    ],
    "xhikwor": [
        8183,
        8184,
        8185
    ],
    "x̌ik zik": [
        8183,
        8184,
        8185
    ],
    "x̌ik": [
        8183,
        8184,
        8185
    ],
    "x̌ikwor": [
        8183,
        8184,
        8185
    ],
    "xurima": [
        8194
    ],
    "xianghua": [
        8380
    ],
    "xinjiang mongolian": [
        8398,
        8399
    ],
    "xinjiang": [
        8398,
        8399
    ],
    "xam": [
        8400
    ],
    "xamtanga": [
        8401
    ],
    "xavánte": [
        8409
    ],
    "xadi": [
        8451
    ],
    "xdi": [
        8451
    ],
    "xedi": [
        8451
    ],
    "xide": [
        8451
    ],
    "xədi": [
        8451
    ],
    "xәdi": [
        8451
    ],
    "xerénte": [
        8456
    ],
    "xetá": [
        8458
    ],
    "xhosa": [
        8472,
        8473
    ],
    "xosa": [
        8472,
        8473
    ],
    "xiri": [
        8483
    ],
    "xirikwa": [
        8483
    ],
    "xrikwa": [
        8483
    ],
    "xinca": [
        8485
    ],
    "xincan": [
        8485
    ],
    "xinka": [
        8485
    ],
    "xiriâna": [
        8486
    ],
    "xiriana": [
        8486
    ],
    "xipaya": [
        8489
    ],
    "xipaia": [
        8489
    ],
    "xakriabá": [
        8507
    ],
    "xacriabá": [
        8507
    ],
    "xikriabá": [
        8507
    ],
    "xingoni": [
        8566
    ],
    "xokleng": [
        8579
    ],
    "xakléng": [
        8579
    ],
    "xogléng": [
        8579
    ],
    "xokré": [
        8579
    ],
    "xokrén": [
        8579
    ],
    "xokréng": [
        8579
    ],
    "xucuru": [
        8584
    ],
    "xukuru-kariri": [
        8584
    ],
    "xarba": [
        8639,
        8640
    ],
    "xiaerba": [
        8639,
        8640
    ],
    "xamatari": [
        8642
    ],
    "xochapa": [
        8645
    ],
    "xu": [
        8684
    ],
    "xuhwe": [
        8684
    ],
    "xwela": [
        8693
    ],
    "xwela gbe": [
        8693
    ],
    "xwela-gbe": [
        8693
    ],
    "xweɖa": [
        8693
    ],
    "xwla-gbe": [
        8697
    ],
    "xuwiina’": [
        8729,
        8730
    ],
    "xuwiina": [
        8730
    ],
    "xiuba": [
        8792
    ],
    "xishanba lalo": [
        8952
    ],
    "xishanba": [
        8952
    ],
    "xidzaʼ": [
        8986
    ],
    "xidza’": [
        8986
    ],
    "xadani": [
        8992
    ],
    "xadani zapotec": [
        8992
    ],
    "xiong": [
        9015
    ],
    "xui": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "xamang": [
        9110
    ],
    "xá lá vàng": [
        9110
    ],
    "xá mang": [
        9110
    ],
    "xá ó": [
        9110
    ],
    "xhon": [
        9136
    ],
    "xanica": [
        9137
    ],
    "xanica zapotec": [
        9137
    ],
    "xanaguía": [
        9161
    ],
    "xanaguía zapotec": [
        9161
    ]
};
